<template>
  <div class="container-fluid">
    <div data-widget-group="group1">
      <ol class="breadcrumb">
        <li class="active"><router-link to="/admin">Dashboard</router-link></li>
        <li class="active"><a href="#">Change Role And Permission</a></li>
      </ol>
        <div v-if="SuccessMessage" class="alert-info alert visibility" role="alert">
            {{ SuccessMessage }}
          </div>
        <div class="panel-body locationform">
          <div
            v-if="message"
            class="alert-danger alert visibility"
            role="alert"
          >
            {{ message }}
          </div>
         
          <div class="col-md-6">
            <div class="form-group">
              <label>Select Role</label>
              <SelectReoles
              :selectedOptionArray ="RoleAlready"
              :remoteControl="'kspgAPI/RoleAndPermission/Role/roleList'" @selectedData="RoleSelectFunction"
        ></SelectReoles>
            </div>
             
          </div>
          <div class="col-md-6">
            <br>
            <br>
            <button class="btn btn-primary submitbtn btn-raised" @click="$router.push('/AddRole')">Add Role +</button>
          </div>
          <div class="col-md-12">
         <div class="form-group">
            <div class="col-md-12"><b> Choose Module </b></div>
            <div class="col-md-6"> <b> Selected </b></div>
            <div class="col-md-6"> <b> &nbsp;&nbsp;&nbsp;Not Selected </b></div>
           <ModuleDualListBox
                :source="ModuleSource" 
                :destination="ModuleDestination"
                label="name"
                @onChangeList="ModuleOnChangeList"
           ></ModuleDualListBox>
         </div>
         <div><button v-on:click="updateModule" class="btn btn-primary submitbtn btn-raised pull-right">Update Module</button></div>           
       </div>
          
       
        <div class="col-md-12">
          <div class="form-group">
            <div class="col-md-12"><b> Choose Permission </b></div>
            <div class="col-md-6"> <b> Selected </b></div>
            <div class="col-md-6"> <b> &nbsp;&nbsp;&nbsp;Not Selected </b></div>
              <DualListBox
                :source="source" 
                :destination="destination"
                label="name"
                @onChangeList="onChangeList"
            />
          </div> 
          <div><button v-on:click="updateRole" class="btn btn-primary submitbtn btn-raised pull-right"> Submit</button></div>           
        </div>          
        </div>
      
    </div>
    
  </div>
</template>
<script>
import commonServices from '../../services/common-services';
import "dual-listbox-vue/dist/dual-listbox.css";

export default {
  name: 'addMechanics',
  data() {
    return {
      selectedRole:'',
      selectedCustomerSegment: null,
      termsAccept: 'Not Accepted',
      loading: false,
      message: '',
      SuccessMessage:'',
      ModuleSource:[],
      ModuleDestination:[],
      source: [],
      destination: [],
      RoleAlready:{},
    };
  },
  components: {
    SelectReoles:() => import( '../components/Select2SearchWithTokenPrefetch.vue'),
    ModuleDualListBox:() => import('dual-listbox-vue'),
    DualListBox:() => import('dual-listbox-vue')
  },
  beforeCreate() {
    this.$store.commit('SET_LAYOUT', 'app-layout');
  },
  methods: {
    onChangeList: function ({ source, destination }) {
            this.source = source;
            this.destination = destination;
    },
    ModuleOnChangeList: function ({ source, destination }) {
            this.ModuleSource = source;
            this.ModuleDestination = destination;
    },
    RoleSelectFunction: function(roleId){
      this.skyloStart()
      let loader = this.$loading.show();
       let params = {};
        params['selectedRole'] = roleId;
        this.selectedRole = roleId;
      /*bajajAPI/user/list*/
      commonServices
        .get('kspgAPI/RoleAndPermission/Role/', params)
        .then((response) => {
          const {
            ModuleSource,
            ModuleDestination,
            source,
            destination
          } = response.data;
          this.source = source;
          this.destination = destination;
          this.ModuleSource = ModuleSource;
            this.ModuleDestination = ModuleDestination;
        })
        .catch((e) => {
          console.log(e);
        });
        this.skyloEnd();
        setTimeout(() => {loader.hide()}, 1000)
    },
    updateModule: function(){
      this.skyloStart()
      let loader = this.$loading.show();
      let data = {};
      data['ModuleSource'] = this.ModuleSource;
      data['ModuleDestination'] = this.ModuleDestination;
      data['selectedRole'] = this.selectedRole;
       
      commonServices.put('kspgAPI/RoleAndPermission/Role/module',data).then(
                 (responce) => {
              this.SuccessMessage = responce.data.message;
              setTimeout(() => (this.SuccessMessage = false), 5000);
              this.skyloEnd();
              setTimeout(() => {loader.hide()}, 1000)
            },(error) => {
                //   this.loading = false;
                    this.message =
                        (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                        setTimeout(() => (this.message = false), 5000);
                        this.skyloEnd();
                        setTimeout(() => {loader.hide()}, 1000)
                }
            ).catch(e => {
                this.errors.push(e)
                })},
    updateRole: function(){
      this.skyloStart()
      let loader = this.$loading.show();
      let data = {};
      data['source'] = this.source;
      data['destination'] = this.destination;
      commonServices.put('kspgAPI/RoleAndPermission/Role/',data).then(
                 (responce) => {
              this.SuccessMessage = responce.data.message;
              setTimeout(() => (this.SuccessMessage = false), 5000);
              this.skyloEnd();
              setTimeout(() => {loader.hide()}, 1000)
            },(error) => {
                //   this.loading = false;
                    this.message =
                        (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                        setTimeout(() => (this.message = false), 5000);
                        this.skyloEnd();
                        setTimeout(() => {loader.hide()}, 1000)
                }
            ).catch(e => {
                this.errors.push(e)
                })
    }
  },
  created() {},
  mounted() {
   
    
  },
};
</script>
<style scoped>
.tab-container {
  font-size: small;
}
.radio1 > label {
  padding: 10px;
}
.btn-primary {
  color: cyan;
}

.visibility {
  visibility:visible !important;
}
</style>
